// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__158w_","buttons":"PendingPaymentAlert_buttons__3tGVP"};